import type {TimelineItem} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@primer/react'
import {TimelineAuthor} from '../TimelineAuthor'
import {formatCopilotWorkSummaryText} from './format-copilot-work-summary-text'

export function CopilotWorkStartedEventText({item}: {item: TimelineItem}) {
  const info = item.additionalInfo?.info
  const onBehalfOf = info?.case === 'copilotWorkStartedEvent' ? info.value.onBehalfOf : undefined
  const sessionUrl = info?.case === 'copilotWorkStartedEvent' ? info.value.sessionUrl : undefined
  const summary = info?.case === 'copilotWorkStartedEvent' ? info.value.summary : undefined
  const actionText = summary ? formatCopilotWorkSummaryText(summary) : 'started reviewing'

  return (
    <>
      <span className="mr-1">
        {sessionUrl ? (
          <Link inline href={sessionUrl} className="fgColor-default text-semibold">
            {actionText}
          </Link>
        ) : (
          <span>{actionText}</span>
        )}
        <span> on behalf of</span>
      </span>{' '}
      <TimelineAuthor
        avatarUrl={onBehalfOf?.avatarUrl}
        login={onBehalfOf?.displayLogin}
        slug={onBehalfOf?.slug}
        userType={onBehalfOf?.userType}
      />
    </>
  )
}
